const BuyButton = ({ customerDataSent }) => {
  return (
    <section>
      <button
        className='btn w-100 py-3 mt-0 text-break'
        type='submit'
        disabled={!customerDataSent}
      >
        <span>Comprar Agora</span>
      </button>
      {!customerDataSent && (
        <span className='alert-fields-invalid'>
          Preencha <b>TODOS</b> os campos corretamente
        </span>
      )}
    </section>
  );
};

export default BuyButton;
